var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStarIconOff(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.78463 1.89551C10.0687 1.89551 10.3284 2.05601 10.4554 2.3101L12.3896 6.17846L16.6426 6.79707C16.9251 6.83816 17.1597 7.03603 17.2479 7.3075C17.3361 7.57898 17.2626 7.87699 17.0582 8.07626L13.9629 11.0942L14.6592 15.3494C14.7052 15.6306 14.5878 15.9136 14.3564 16.0798C14.1249 16.246 13.8192 16.2666 13.5675 16.133L9.78463 14.1258L6.00179 16.133C5.75007 16.2666 5.4444 16.246 5.2129 16.0798C4.98141 15.9136 4.86408 15.6306 4.9101 15.3494L5.6064 11.0942L2.51105 8.07626C2.30667 7.87699 2.23313 7.57898 2.32133 7.3075C2.40954 7.03603 2.6442 6.83816 2.92667 6.79707L7.17963 6.17846L9.11381 2.3101C9.24085 2.05601 9.50055 1.89551 9.78463 1.89551Z",
    fill: "#E8E8E8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarIconOff);
export default __webpack_public_path__ + "static/media/starIconOff.252250a6a100e0a13cc8157063b6554f.svg";
export { ForwardRef as ReactComponent };